module.exports = __webpack_public_path__ + "img/index_banner_1.e9cf3b98.jpg";